export class ValidatePanResponse{
    public isValidPan: boolean;
    public canBindNewUser: boolean;
    public psCardId: string;
}

export class BindRequest{
    public psCardId: string;
    public personGuid?: string;
    public vehicleGuid?: string;
    public cardholderGuid?: string;
    public assignorGuid: string;
    public managerGuid: string;
    public pan: string;
    public cvv: string;
    public validityDate: string;
    public cardPin?: string;
    public cardPinConfirm?: string;
}

export class UpdateRequest{
    public psCardId: string;
    public managerGuid: string;
    //public smsPin: number;
    public newCardPin?: number;
    public confirmNewCardPin?: number;
}

export class BlockRequest{
    public psCardId: string;
    public managerGuid: string;
    public password?: string;
    public conductorGuid?: string;
}
